import type {AJAXResponseProductData} from '@Panels/poster-publishing-options-panel/poster-publishing-options-panel.types';
import React, {ReactElement} from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import {Button, IconPlacement, Size, Type} from '@Components/button';
import styles from '@Panels/poster-publishing-options-panel/components/publishing-digital-signage-list/components/publishing-yodeck-panel/publishing-yodeck-panel.module.scss';
import type {VoidFunction} from '@Utils/general.util';

export function useBuildIframeEmbedSnippet(displayCodeGenerated: string, productUsed: AJAXResponseProductData): string {
  if (productUsed) {
    const {width, height} = productUsed;
    const srcLink = window.PMW.util.site_url(`v/d/`);

    if (typeof srcLink !== 'undefined') {
      return `<iframe width="${width}" height="${height}" src="${srcLink}${displayCodeGenerated}" frameborder="0" allowfullscreen></iframe>`;
    }
  }
  return '';
}

export const useCopyButton = (
  clicked: boolean,
  generatedIframe: string,
  setClicked: {(value: React.SetStateAction<boolean>): void; (arg0: boolean): void},
  onCopyClick?: VoidFunction
): ReactElement => {
  return (
    <OverlayTrigger
      trigger={['hover', 'focus']}
      placement="top"
      delay={{show: 50, hide: 100}}
      overlay={
        clicked ? (
          <Tooltip id="tooltip" className="_pointer-events-none spacing-m-b-1">
            {window.i18next.t('pmwjs_link_copied')}
          </Tooltip>
        ) : (
          <div />
        )
      }
      show={clicked}
      defaultShow={undefined}
      flip={undefined}
      onHide={undefined}
      onToggle={undefined}
      popperConfig={undefined}
      target={undefined}
    >
      <Button
        isFullWidth
        type={clicked ? Type.SUCCESS : Type.PRIMARY}
        size={Size.SMALL}
        iconPlacement={IconPlacement.LEFT}
        text={clicked ? window.i18next.t('pmwjs_copied_share_dropdown_link') : window.i18next.t('pmwjs_copy_link')}
        icon={clicked ? 'icon-check' : 'icon-link'}
        onClick={() => {
          window.PMW.copyTextToClipboard(generatedIframe);
          if (onCopyClick) {
            onCopyClick();
          }
          setClicked(true);
        }}
        customClasses={`flex-1 ${styles.noWrapText}`}
      />
    </OverlayTrigger>
  );
};
